import DOMPurify from 'dompurify';

export default {
  name: 'sanitize-mixin',
  methods: {
    sanitizedHtml(html) {
      return DOMPurify.sanitize(this.decodeHtml(html).replace(/\r?\n/g, '<br>'));
    },
    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
  },
};
